import QRCode from 'qrcode';
import { post } from './Request';

/** 下载页路径（固定参数） */
const DOWNLOAD_PATH = '/financial/download-app?ch=sale&id=4555882523';

/** 模块级单例 Promise —— 防止并发重复请求 */
let downloadUrlPromise: Promise<string> | null = null;

/**
 * 获取动态下载链接
 * 调用 /common/getRiskSceneDomain 获取域名，拼接完整下载URL
 */
export function getDownloadUrl(): Promise<string> {
	if (!downloadUrlPromise) {
		downloadUrlPromise = post({
			url: '/gate/common/getRiskSceneDomain',
			data: { scene: 'download_app' },
			apiType: 'gatewayApi',
		})
			.then((res: any) => {
				let domain = res?.data?.campDomain;
				if (!domain) {
					throw new Error('campDomain is empty');
				}
				// 兼容返回值不含协议头的情况
				if (!/^https?:\/\//.test(domain)) {
					domain = `https://${domain}`;
				}
				// 去除末尾斜杠，避免拼接出双斜杠
				return `${domain.replace(/\/+$/, '')}${DOWNLOAD_PATH}`;
			})
			.catch((err) => {
				downloadUrlPromise = null; // 失败重置，允许重试
				throw err;
			});
	}
	return downloadUrlPromise;
}

/** 模块级 QR DataURL 缓存 —— 同一URL只生成一次 */
let qrDataUrlCache: string | null = null;

/**
 * 生成下载二维码 Data URL
 * @param size 输出图片像素宽度（建议2x物理像素）
 */
export async function getDownloadQrDataUrl(size: number = 208): Promise<string> {
	if (qrDataUrlCache) {
		return qrDataUrlCache;
	}
	const url = await getDownloadUrl();
	const dataUrl = await QRCode.toDataURL(url, {
		width: size,
		margin: 2,
		color: { dark: '#000000', light: '#ffffff' },
	});
	qrDataUrlCache = dataUrl;
	return dataUrl;
}
